<template>
  <div class="footer">
    <div class="footer-box">
      <div class="footer-logobox">
        <div>賽馬會「翻轉教學」先導計劃</div>
        <div class="footer-main-logo">
          <div><a href="http://jcflippedlearning.hk" target="_blank">
            <img class="footer-logoimg1" src="@/assets/image/logo/flippedlearning.png" style="width: auto; height: 162px; padding-top: 29px;">
          </a></div>
        </div>
      </div>
      <hr>
      <div class="footer-logobox">
        <div>主辦機構</div>
        <div class="footer-main-logo">
          <div><a href="http://www.cuhk.edu.hk/chinese/index.html" target="_blank">
            <img class="footer-logoimg" src="@/assets/image/logo/culogo.png" style="height: 136px; padding-right: 10px;">
          </a></div>
          <div><a href="https://www.hkbu.edu.hk/tch/main/index.jsp" target="_blank">
            <img class="footer-logoimg" src="@/assets/image/logo/bulogo.png" style="height: 134px;">
          </a></div>
        </div>
      </div>
      <hr>
      <div class="footer-logobox">
        <div>捐助機構</div>
        <div><a href="https://charities.hkjc.com/" target="_blank">
          <img class="footer-logoimg" src="@/assets/image/logo/hkjc.png" style="width: 283px;">
        </a></div>
      </div>
      <hr>
      <div class="footer-logobox">
        <div>協作機構</div>
        <div><a href="https://flippeducatorshk.wixsite.com/website" target="_blank">
          <img class="footer-logoimg" src="@/assets/image/logo/flippeducatorshk.png" style="
    height: 48px;">
        </a></div>
      </div>
      <!-- <hr> -->
    </div>
  </div>
</template>

<style scoped>
  .footer{
    background-color: #F5F5F5;
    color: #838787;
    padding: 2rem;
    font-size: 1rem;
    display:flex;
    justify-content: space-around;

    top: calc( 100% - 190px );
    position: sticky;
    width: 100%;
  }
  .footer-box{
    display:flex;
    margin:auto;
  }
  hr{
    margin:0 1rem;

    display: initial !important;
    height: inherit !important;
    border-bottom-style:inset !important;
    border-bottom-width:1px !important;
    border-left-style:inset !important;
    border-left-width:1px !important;
    border-right-style:inset !important;
    border-right-width:1px !important;
    border-top-color:rgb(238, 238, 238) !important;
    border-top-style:solid !important;
    border-top-width:1px !important;
    padding: initial !important;

    margin-top: initial !important;
    margin-bottom: initial !important;

    -webkit-box-sizing: initial !important;
    -moz-box-sizing: initial !important;
    box-sizing: initial !important;
  }
  .footer-userhelp-col{
    display: flex;
    flex-direction:column;
    padding: 1rem 0;
  }
  .footer-main-logo{
    display: flex;
  }
  .footer-logoimg{
    /*width: 12rem;
    margin: 1rem;*/
  }
  .footer-logoimg1{
    /*width: 9rem;
    margin: 1rem;*/
  }
  .footer-logobox{
    display:flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .footer-flippedlearn-text{
    padding: 1rem 0;
  }
  @media screen and (max-width: 790px) {
    .footer-box{
      display: block;
    }
    .footer-box hr{
      display: none !important;
    }
    .loginPage{
      justify-content: center;
    }
    .footer-main-logo{
      display: block;
    }
  }
</style>
<script type="text/javascript">
import { EvaIcon } from 'vue-eva-icons'
export default {
  components: {
    [EvaIcon.name]: EvaIcon
  }
}
</script>
